import React, { useEffect, useState } from 'react'
import style from './leftPanelMain.module.scss'
import { Button } from 'antd'
import { useAppSelector } from '../../starter/hooks/redux'
import { store } from '../../starter/redux/store'
import CreateEmployee from '../../components/CreateEmployee/CreateEmployee'
import CreateProject from '../../components/CreateProject/CreateProject'
import { useActions } from '../../starter/hooks/actions'
import { useCreateEmployeesMutation } from '../../starter/api/employeesApi'
import { useCreateProjectsMutation } from '../../starter/api/projectsApi'
import { PlusIcon } from '../../images/icons'
import { useCreateProjectManagerMutation } from '../../starter/api/projectManagersApi'
import CardListEmployees from '../../components/CardListEmployees/CardListEmployees'
import CardListProjects from '../../components/CardListProjects/CardListProjects'
import CardListProjectManagers from '../../components/CardListProjectManagers/CardListProjectManagers'
import { useDrop } from 'react-dnd'
import { ITmpEmployee, ITmpProject, ITmpProjectManager } from '../../starter/model/interfaces'
import CreateProjectManager from '../../components/CreateProjectManager/CreateProjectManager'

export default function LeftPanelMain() {
  const { projectManagers } = useAppSelector((state) => state.projectManagers)
  const [
    createEmployee,
    { isSuccess: isSuccessCreateEmployee, isError: isErrorCreateEmployee, error: createEmployeeError }
  ] = useCreateEmployeesMutation()
  const [
    createProject,
    { isSuccess: isSuccessCreateProject, isError: isErrorCreateProject, error: createProjectError }
  ] = useCreateProjectsMutation()
  const [
    createProjectManager,
    { isSuccess: isSuccessCreateProjectManager, isError: isErrorCreateProjectManager, error: createProjectManagerError }
  ] = useCreateProjectManagerMutation()
  const [tabItem, setTabItem] = useState<any[]>([])

  const [selectedTab, setSelectedTab] = useState<any>(undefined)
  const { setError, setButtonSet, onShowModal, setModalData, setTmpEmployee, setTmpProjectManager, setTmpProject } =
    useActions()

  useEffect(() => {
    if (isErrorCreateEmployee || isErrorCreateProject || isErrorCreateProjectManager) {
      setError({
        isError: true,
        message:
          // @ts-ignore
          (createEmployeeError && createEmployeeError.data) ||
          // @ts-ignore
          (createProjectError && createProjectError.data) ||
          // @ts-ignore
          (createProjectManagerError && createProjectManagerError.data)
      })
    }
  }, [
    isErrorCreateEmployee,
    isErrorCreateProject,
    isErrorCreateProjectManager,
    createEmployeeError,
    createProjectError,
    createProjectManagerError
  ])

  useEffect(() => {
    if (isSuccessCreateEmployee || isSuccessCreateProject || isSuccessCreateProjectManager) {
      onShowModal(false)
    }
  }, [isSuccessCreateEmployee, isSuccessCreateProject, isSuccessCreateProjectManager])

  const addEmployeeHandler = () => {
    onShowModal(true)
    setButtonSet([
      {
        type: 'primary',
        onClick: () => {
          const { employee } = { ...store.getState().tmp }
          if (employee && employee.validate?.isValid) {
            createEmployee(employee)
          } else {
            // todo что-то странное ниже
            const _employee: ITmpEmployee = JSON.parse(JSON.stringify(employee)) //{...employee}
            _employee.validate.showError = true
            setTmpEmployee(_employee)
          }
        },
        children: 'Ok'
      },
      {
        onClick: () => onShowModal(false),
        children: 'Cancel'
      }
    ])
    setModalData({
      title: 'Введите данные нового сотрудника',
      content: <CreateEmployee />
    })
  }
  const addProjectHandler = () => {
    onShowModal(true)
    setButtonSet([
      {
        type: 'primary',
        onClick: () => {
          const { project } = { ...store.getState().tmp }
          if (project && project.validate?.isValid) {
            createProject(project)
          } else {
            // todo что-то странное ниже
            const _project: ITmpProject = JSON.parse(JSON.stringify(project)) //{...employee}
            _project.validate.showError = true
            setTmpProject(_project)
          }
        },
        children: 'Ok'
      },
      {
        onClick: () => onShowModal(false),
        children: 'Cancel'
      }
    ])
    setModalData({
      title: 'Введите данные нового проекта',
      content: <CreateProject />
    })
  }
  const addProjectManagerHandler = () => {
    onShowModal(true)
    setButtonSet([
      {
        type: 'primary',
        onClick: () => {
          const { projectManager } = { ...store.getState().tmp }
          if (projectManager && projectManager.validate?.isValid) {
            createProjectManager(projectManager)
          } else {
            // todo что-то странное ниже
            const _projectManager: ITmpProjectManager = JSON.parse(JSON.stringify(projectManager)) //{...employee}
            _projectManager.validate.showError = true
            setTmpProjectManager(_projectManager)
          }
        },
        children: 'Ok'
      },
      {
        onClick: () => onShowModal(false),
        children: 'Cancel'
      }
    ])
    setModalData({
      title: 'Введите данные нового менеджера проектов',
      content: <CreateProjectManager />
    })
  }

  const [{ isActive, itemType }, dropRef] = useDrop({
    accept: ['employee', 'project'],
    drop(item: any, monitor) {},
    collect: (monitor) => ({
      isActive: monitor.canDrop() && monitor.isOver(),
      itemType: monitor.getItemType()
    })
  })
  // Проверяем что тащим на левую панель. Если тип объекта отличается от активной вкладки, то переключаем активную вкладку
  useEffect(() => {
    if (selectedTab && selectedTab.key && itemType && itemType !== selectedTab.key) {
      const item = tabItem.find((i) => i.key === itemType)
      if (item) {
        setSelectedTab(item)
      }
    }
  }, [itemType])

  useEffect(() => {
    const _tabItem = [
      {
        label: `Сотрудники`,
        key: `employee`,
        disabled: false,
        children: <CardListEmployees />,
        addButton: (
          <Button className={style.addButton} onClick={addEmployeeHandler}>
            <div className={style.plusIcon}>
              <PlusIcon />
            </div>
          </Button>
        )
      },
      {
        label: `Проекты`,
        key: `project`,
        disabled: false,
        children: <CardListProjects />,
        addButton: (
          <Button className={style.addButton} onClick={addProjectHandler}>
            <div className={style.plusIcon}>
              <PlusIcon />
            </div>
          </Button>
        )
      },
      {
        label: `ПМ`,
        key: `pm`,
        disabled: false,
        children: <CardListProjectManagers />,
        addButton: (
          <Button className={style.addButton} onClick={addProjectManagerHandler}>
            <div className={style.plusIcon}>
              <PlusIcon />
            </div>
          </Button>
        )
      }
    ]
    setTabItem(_tabItem)
    if (!selectedTab) {
      setSelectedTab(_tabItem[0])
    }
  }, [projectManagers, selectedTab])

  return (
    <div className={style.wrapper} ref={isActive ? dropRef : null}>
      <div className={style.tabs}>
        {tabItem.length > 0 &&
          tabItem.map((item) => {
            return (
              <div
                key={item.key}
                className={`${style.tabItem} ${selectedTab.key === item.key ? style.selected : ''}`}
                onClick={() => {
                  setSelectedTab(item)
                }}>
                {item.label}
              </div>
            )
          })}
      </div>
      <div className={style.tabBody}>{selectedTab && selectedTab.children}</div>
      <div className={style.buttonWrapper}>{selectedTab && selectedTab.addButton}</div>
    </div>
  )
}
